import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getSettings(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/settings`);
  }

  getSettingByCode(code: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/settings/${code}`);
  }

  /**
   * Get multiple settings by comma-separated codes (e.g. 'year,month,period')
   */
  getSettingsByCodes(codes: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/settings/by-codes/${codes}`);
  }

  /**
   * Create a new setting
   * @param setting { code: string; type: string; description?: string }
   */
  createSetting(setting: { code: string; type: string; description?: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/api/settings`, setting);
  }

  /**
   * Update an existing setting
   * @param setting { code: string; type: string; description?: string }
   */
  updateSetting(id: number, setting: { code: string; type: string; description?: string }): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/api/settings/${id}`, setting);
  }

  /**
   * Filter settings by code and parent (used for cascading address dropdowns)
   * e.g. filterSettings('province', 'NCR') returns all provinces under NCR
   */
  filterSettings(code: string, parent: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/api/settings/filter`, { params: { code, parent } });
  }
}
